module.exports = ".exa-file-can-upload {\n\n}\n\n.exa-file-exists {\n    padding: 0.375rem 0.75rem;\n}\n\n.exa-file-not-exists {\n    margin-bottom: 5px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/exa/exa-file/exa-file.component.css
// module id = ./src/app/exa/exa-file/exa-file.component.css
// module chunks = main